import React, { useContext, useEffect, useState } from 'react';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import LazyLoading from "../../components/LazyLoading";
import { Col, Form, Modal, Row } from "@themesberg/react-bootstrap";
import fetchWrapper from "../../utils/fetch/fetchWrapper";
import adaptedImageUrl, { BASE_URL } from "../../config";
import { LOCAL_STORAGE } from "../../context/LocalStorage";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import 'react-data-table-component-extensions/dist/index.css';
const ModalDetails = ({ showModal, setShowModal, id, setId}) => {

    const [dataOrder, setDataOrder] = useState([]);
    const [data, setData] = useState([]);
    const [imageSelected, setImageSelected] = useState(null);
    const [lightboxImage, setLightboxImage] = useState(false);
    const MySwal = withReactContent(Swal)

    const fetchData = () => {
        fetchWrapper()
          .doGet({
              url: "/get_answers?user_id=" + id,           
              onSuccess: async (response) => {
                  setDataOrder(response.data.equipment)
                  setData(response.data.images)
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
    }
    useEffect(() => {
        fetchData()        
    }, [showModal]);
    const setImageLightbox = (image_url) => {
        setImageSelected(image_url)
        setLightboxImage(true)
    }
    const handleApprovedVerificationImageCheckboxChange = (event) => {

        var idCheck = event.target.value;

        MySwal.fire({
            title: <p>¿Está seguro de cambiarle el estado a la pregunta?</p>,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            didOpen: () => {
            }
        }).then((result) => {
            if (result.value) {
                fetchWrapper()
          .doPost({
              url: "/approved_verification_question",
              body:{
                  verification_id: idCheck
              },
              onSuccess: async (response) => {
                fetchData()
                Swal.fire(
                    'Confirmado!',
                    'Se ha cambiado el estado.',
                    'success'
                )
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
                
            }
        })
    }
    const handleRejectededVerificationImageCheckboxChange = (event) => {

        var idCheck = event.target.value;

        MySwal.fire({
            title: <p>Esta seguro de cambiarle el estado a la pregunta?</p>,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar',
            didOpen: () => {
            }
        }).then((result) => {
            if (result.value) {
                fetchWrapper()
          .doPost({
              url: "/rejected_verification_question",
              body:{
                  verification_id: idCheck
              },
              onSuccess: async (response) => {
                fetchData()
                Swal.fire(
                    'Confirmado!',
                    'Se ha cambiado el estado.',
                    'success'
                )
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
                
            }
        })
    }
    const customLightboxStyles = {
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 999999999999999,
        },
      };
    

    const CustomImage = ({ row }) => (
        <div>
            {row &&
                [   
                    <div onClick={() => setImageLightbox(adaptedImageUrl(row.image_url))}>
                        <img height="100px" width="100px" className="w-full  align-middle border-none shadow-lg"
                            src={adaptedImageUrl(row.image_url) ?? null} />
                    </div>,
                    // <center>
                    //     <label>Aceptar</label>
                    //     <label class="form-check form-switch"><input class="form-check-input" value={row.id} checked={row.approved == 1 ? true : false}
                    //         type="checkbox"
                    //         onChange={handleApprovedVerificationImageCheckboxChange} /><span
                    //             class="slider round"> </span></label>
                    //     <label>Rechazar</label>
                    //     <label class="form-check form-switch"><input class="form-check-input" value={row.id} checked={row.rejected == 1 ? true : false}
                    //         type="checkbox"
                    //         onChange={handleRejectededVerificationImageCheckboxChange} /><span
                    //             class="slider round"> </span></label>
                    // </center>
                    ]
                
            }

        </div>
        );
        const CustomVerificationImage = ({ row }) => (
            <div>
                {row &&
                    [   
                        // <div onClick={() => setImageLightbox(adaptedImageUrl(row.image_url))}>
                        //     <img height="100px" width="100px" className="w-full  align-middle border-none shadow-lg"
                        //         src={adaptedImageUrl(row.image_url) ?? null} />
                        // </div>,
                        <center>
                            <label>Aceptar</label>
                            <label class="form-check form-switch"><input class="form-check-input" value={row.id} checked={row.approved == 1 ? true : false}
                                type="checkbox"
                                onChange={handleApprovedVerificationImageCheckboxChange} /><span
                                    class="slider round"> </span></label>
                            <label>Rechazar</label>
                            <label class="form-check form-switch"><input class="form-check-input" value={row.id} checked={row.rejected == 1 ? true : false}
                                type="checkbox"
                                onChange={handleRejectededVerificationImageCheckboxChange} /><span
                                    class="slider round"> </span></label>
                        </center>
                        ]
                    
                }
    
            </div>
            );
            

    const handleClose = () => {
        setShowModal(false);
        setId(null)
    }
    const columns = [
        {
            name: "Pregunta",
            grow: 3,
            selector: "question"
        },
        {
            name: "Respuesta",
            selector: "respuesta",
            grow:3
        }, 
        {
            name: "Verificacion",
            grow: 0,
            cell: row => <CustomVerificationImage row={row}/>,
        }               
    ];
    const columnItem = [
        {
            name: "Fotos del Equipamiento",
            grow: 3,
            cell: row => <CustomImage row={row} />,
        },        
    ];
    return (
        <Modal show={showModal} onHide={() => handleClose()}

            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Detalles del Equipamiento
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div >
                    <h4>Preguntas: </h4>
                    <DataTable
                        columns={columns}
                        data={dataOrder}
                    />
                </div>
                <div className="row mt-5 ">
                    <h4>Equipamiento:</h4>
                </div>
                <DataTable
                    columns={columnItem}
                    data={data}
                    pagination
                    noHeader
                    paginationPerPage={10}
                />
                {lightboxImage && (
                <Lightbox
                    mainSrc={imageSelected}
                    onCloseRequest={() => setLightboxImage(false)}
                    reactModalStyle={customLightboxStyles}
                />
            )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-light" onClick={() => handleClose()}>Cerrar</button>
            </Modal.Footer>
        </Modal>


    );
    
    
};

export default ModalDetails

